
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.022 1.337a6.685 6.685 0 100 13.37 6.685 6.685 0 000-13.37zm-5.18 5.348a5.358 5.358 0 000 2.674h1.9a14.046 14.046 0 010-2.674h-1.9zm.547-1.337h1.553c.142-.684.338-1.31.578-1.852.04-.09.082-.18.126-.266a5.372 5.372 0 00-2.257 2.118zm2.697 1.337a12.641 12.641 0 000 2.674h3.872a12.652 12.652 0 000-2.674H6.086zm3.646-1.337h-3.42c.116-.49.262-.93.43-1.309.22-.493.463-.85.7-1.076.234-.222.428-.289.58-.289.152 0 .347.067.58.289.237.225.48.583.7 1.076.168.379.314.82.43 1.31zm1.57 1.337a14.04 14.04 0 010 2.674h1.9a5.357 5.357 0 000-2.674h-1.9zm1.353-1.337h-1.553a9.163 9.163 0 00-.578-1.852c-.04-.09-.082-.18-.126-.266.945.469 1.73 1.209 2.257 2.118zm-7.01 7.467a5.372 5.372 0 01-2.256-2.119h1.553c.142.685.338 1.31.578 1.852.04.09.082.18.126.267zm1.097-.81a7.512 7.512 0 01-.43-1.309h3.42c-.116.49-.262.93-.43 1.31-.22.493-.463.85-.7 1.076-.233.222-.428.288-.58.288-.152 0-.346-.066-.58-.288-.237-.226-.48-.583-.7-1.077zm3.782.543c.24-.541.436-1.167.578-1.852h1.553a5.373 5.373 0 01-2.257 2.119c.044-.087.086-.176.126-.267z","fill":"currentColor"}})])
          )
        }
      }
    